export default __webpack_public_path__ + "static/media/lb_badge.da8b6083.png";